import React, { useEffect } from "react";
import Common_title from "../common-components/common-title/Common_title";

const Terms_Conditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="Privacy_policy">
      <div className="container">
        <Common_title subtitle="Terms & Conditions" />

        <div className="white_card">
          <p className="point_title">Effective Date: 29.04.2026</p>
          <p className="descn_text">
            Welcome to Loconex. By using our mobile application (“App”), you
            agree to the following Terms & Conditions. Please read them
            carefully.
          </p>
          <p className="point_title">1. Acceptance of Terms</p>
          <p className="descn_text">
            By accessing or using Loconex, you agree to be bound by these Terms.
            If you do not agree, please do not use the App.
          </p>
          <p className="point_title">2. Services</p>
          <p className="descn_text">
            Loconex is a platform that connects customers with vendors and
            service providers. We act only as an intermediary and are not
            directly responsible for the products or services offered by
            vendors.
          </p>
          <p className="point_title">3. User Accounts</p>
          <ul className="descn_text">
            <li>
              You must provide accurate and complete information during
              registration
            </li>
            <li>You are responsible for maintaining account confidentiality</li>
            <li>
              You agree not to misuse the app or engage in illegal activities
            </li>
          </ul>
          <p className="point_title">4. Vendor Responsibility</p>
          <p className="descn_text">
            Vendors are responsible for product quality, pricing, and service
            delivery Loconex does not guarantee the accuracy or quality of
            vendor offerings
          </p>
          <p className="point_title">5. Payments</p>
          <p className="descn_text">
            Payments may be processed via third-party payment gateways Loconex
            is not responsible for payment failures due to technical issues
          </p>
          <p className="point_title">6. Prohibited Activities</p>
          <p className="descn_text">Users must not:</p>
          <ul className="descn_text">
            <li>Use the app for fraud or illegal purposes</li>
            <li>Upload false, misleading, or harmful content</li>
            <li>Attempt to hack, damage, or disrupt the platform</li>
          </ul>
          <p className="point_title">7. Intellectual Property</p>
          <p className="descn_text">
            All content, logos, and features of Loconex are owned by us and
            protected by applicable laws.
          </p>
          <p className="point_title">8. Limitation of Liability</p>
          <p className="descn_text">Loconex is not liable for:</p>{" "}
          <ul className="descn_text">
            <li>Vendor product/service quality</li>
            <li>Delays, cancellations, or losses caused by vendors</li>
            <li>Any indirect or incidental damages</li>
          </ul>
          <p className="point_title">9. Termination</p>
          <p className="descn_text">
            We reserve the right to suspend or terminate accounts that violate
            these terms.
          </p>
          <p className="point_title">10. Changes to Terms</p>
          <p className="descn_text">
            We may update these Terms at any time. Continued use of the app
            means you accept the updated terms. 11. Contact Us
          </p>
          <p className="point_title">11. Contact Us</p>
          <p className="descn_text">Phone: +91 6262171723</p>
          <div className="refund-policy mt-5">
            <p className="point_title">
              Refund & Cancellation Policy for Loconex App
            </p>
            <p className="point_title">Effective Date: 29.04.2026</p>
            <p className="point_title">1. General Policy</p>
            <p className="descn_text">
              Loconex acts as a platform connecting customers and vendors.
              Refunds and cancellations are primarily handled by the respective
              vendors.
            </p>
            <p className="point_title">2. Cancellation</p>
            <p className="descn_text">
              Orders can be cancelled before they are accepted or processed by
              the vendor Once the order is processed or shipped, cancellation
              may not be possible
            </p>
            <p className="point_title">3. Refund Eligibility</p>
            <p className="descn_text">
              Refunds may be applicable in the following cases:
            </p>
            <ul className="descn_text">
              <li>Product/service not delivered</li>
              <li>Wrong product delivered</li>
              <li>Damaged or defective product</li>
              <li>Duplicate payment</li>
            </ul>
            <p className="point_title">4. Refund Process</p>
            <ul className="descn_text">
              <li>Users must raise a request within [2–5 days] of delivery</li>
              <li>Refund requests will be reviewed and verified</li>
              <li>
                Approved refunds will be processed to the original payment
                method
              </li>
            </ul>
            <p className="point_title">5. Refund Timeline</p>
            <p className="descn_text">
              Refunds are typically processed within 5–10 business days Time may
              vary depending on the payment provider
            </p>
            <p className="point_title">6. Non-Refundable Cases</p>

            <ul className="descn_text">
              <li>Change of mind after delivery</li>
              <li>Minor differences in product appearance</li>
              <li>Services already completed</li>
            </ul>
            <p className="point_title">7. Vendor Responsibility</p>
            <p className="descn_text">
              Vendors are responsible for honoring valid refund requests.
              Loconex may assist in dispute resolution but is not liable for
              vendor decisions.
            </p>
            <p className="point_title">8. Contact for Refund</p>
            <p className="descn_text">Phone: +91 6262171723</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms_Conditions;
